// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as Title from "../../resources/typography/Title.res.js";
import * as Spinner from "../../resources/feedback-indicators/Spinner.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  root: {
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    "marginTop-keoZOQ": "marginTop-x166v9or",
    $$css: "wino-gc:src/app/Loading/LoadingPage.res.js:13"
  }
};
function LoadingPage(props) {
  let __text = props.text;
  let text = __text !== undefined ? __text : I18n.t("Loading...");
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf justifyContent-xl56j7k marginTop-x166v9or",
      "data-style-src": "wino-gc:src/app/Loading/LoadingPage.res.js:13"
    }
  };
  return JsxRuntime.jsxs("div", (newrecord.children = [JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(Spinner.make, {
      size: 30
    }),
    spaceY: "small"
  }), JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(Title.make, {
        children: text,
        level: 3,
        align: "center"
      }),
      spaceY: "xsmall"
    }), JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Please wait."),
        align: "center",
        variation: "normal"
      }),
      spaceX: "xhuge"
    })]
  })], newrecord));
}
let make = LoadingPage;
export { styles, make };
/* styles Not a pure module */